import React from 'react'
import HubspotForm from 'react-hubspot-form'

const M24HubSpotForm = ({ formId, portalId, anchorLinkId }) => {
  return (
    <section className="my-10 overflow-hidden md:my-20" id={anchorLinkId}>
      <div className="container">
        <div className="row-type-g">
          <div className="col-1-type-g3">
            <div className="column-indent-both">
              <HubspotForm
                portalId={portalId}
                formId={formId}
                onSubmit={values => console.log('Submit!', { values })}
                onReady={form => console.log('Form ready!', { form })}
                loading={<div>Loading...</div>}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default M24HubSpotForm
